import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import '../countries-css/waste_county_chart_02.css';
import Content01 from "./group_2021_01";
import Content02 from "./group_2021_02";


export default function Chart() {
  const [counterOn, setCounterOn] = useState(false);
  return (
    <ScrollTrigger
      onEnter={() => setCounterOn(true)}
      onExit={() => setCounterOn(false)}
    >
      <div style={{ position: "relative" }}>
        <div className="chart-box-ban">
          <div className="conserve-waste-chart-01-card-container">
            <div className="conserve-waste-chart-01-card" style={{ width: "120px" }}>
              <center>
                <div className="conserve-waste-chart-01-number number-content-01">
                  {counterOn && (<CountUp start={0} end={   36.7726  } decimals={2} duration={3} delay={0.3} />)}
                </div>
                <div>
                  <Content01 />
                </div>
              </center>
            </div>

            <div className="conserve-waste-chart-01-card" style={{ width: "120px" }}>
              <center>
                <div className="conserve-waste-chart-01-number number-content-02">
                  {counterOn && (<CountUp start={0} end={ 47.86 } decimals={2} duration={3} delay={0.3} />)}
                </div>
                <div>
                  <Content02 />
                </div>
              </center>
            </div>

          </div>
        </div>
      </div>
    </ScrollTrigger>
  );
}
